import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "title"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "Subsection__StyledDiv",
  componentId: "rw0cm0-0"
})(["margin-block-start:", ";margin-block-end:", ";", ""], ({
  theme
}) => theme.space['700'], ({
  theme
}) => theme.space['700'], ({
  $cssStyles
}) => $cssStyles);

/**
 * Subsections are small areas of focused content that can be grouped together as "like items" under a simple, scannable header. A description should not be needed since this header should just be a label. Subsections should exist within sections.
 */
const Subsection = props => {
  const {
      children,
      className,
      title
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(rest);
  const cssProps = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledDiv, Object.assign({
    className: classNames('settings-module', className),
    "data-test-id": "settings-module",
    $cssStyles: cssProps
  }, restProps, {
    children: [title && /*#__PURE__*/_jsx(H5, {
      "aria-level": 4,
      children: title
    }), children]
  }));
};
Subsection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /**
   * Heading for this section.
   */
  title: PropTypes.node
};
export default Subsection;